import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, TreeInfoDTOConverter, ForecastSimulationUpdateDTOConverter, ForecastSimulationConflictDTOConverter, DummyWindowAppendDTOConverter, PromotionSimulationConverter, ForecastSimulationLockDTOConverter, ResourceLockResultDTOConverter, SimulationFindCreateDTOConverter, ForecastSimulationUpdateResultDTOConverter, ForecastSimulationSaveResultDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { GenericTransportLayer } from '../GenericTransportLayer';
import { List, Map as IMap } from 'immutable';
export var ForecastSimulationLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(ForecastSimulationLayer, _GenericTransportLaye);

  function ForecastSimulationLayer() {
    _classCallCheck(this, ForecastSimulationLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationLayer).call(this, CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION));
  }

  _createClass(ForecastSimulationLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.treeInfoDTOConverter;
    }
    /**
     * Fetch resource locks overview for selected promotions
     *
     * @param {List<string>} promotionIds
     */

  }, {
    key: "lockOverview",
    value: function lockOverview(promotionIds) {
      var _this = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_LOCK_OVERVIEW).post({
        promotionIds: promotionIds.toArray()
      }, apiConfig).then(function (response) {
        var map = IMap();
        (response.data.result || []).map(function (item) {
          var lock = _this.forecastSimulationLockDTOConverter.toObject(item, jsonConversions);

          map = map.set(lock.promotionId, lock);
        });
        return map;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Locks resource by simulationId and returns lock result
     *
     * @param {string} simulationId
     * @returns {Promise<ResourceLockResultDTO>}
     */

  }, {
    key: "lock",
    value: function lock(simulationId) {
      var _this2 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_LOCK(simulationId)).get(apiConfig).then(function (response) {
        return _this2.resourceLockResultDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Unlocks resource by simulationId and returns unlock result
     *
     * @param {string} simulationId
     * @returns {Promise<ResourceLockResultDTO>}
     */

  }, {
    key: "unlock",
    value: function unlock(simulationId) {
      var _this3 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_UNLOCK(simulationId)).get(apiConfig).then(function (response) {
        return _this3.resourceLockResultDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Create or find forecast simulation
     *
     * @param {string} promotionId
     */

  }, {
    key: "findOrCreate",
    value: function findOrCreate(promotionId) {
      var _this4 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_FIND_OR_CREATE(promotionId)).get(apiConfig).then(function (response) {
        return _this4.simulationFindCreateDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Fetch {@link PromotionSimulation} object by promotionId
     *
     * @param {string} promotionId
     */

  }, {
    key: "getSimulation",
    value: function getSimulation(promotionId) {
      var _this5 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_GET(promotionId)).get(apiConfig).then(function (response) {
        return _this5.promotionSimulationConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Fetch simulation {@link TreeInfoDTO} nodes
     *
     * @param {string} simulationId
     * @param {ForecastSimulationTreeOptionsDTO} options
     */

  }, {
    key: "getTreeData",
    value: function getTreeData(simulationId, options) {
      var _this6 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_TREE(simulationId)).post(options, apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (item) {
          return _this6.treeInfoDTOConverter.toObject(item, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Update forecast simulation entities based on update DTOs.
     *
     * @param {string} simulationId
     * @param {List<ForecastSimulationUpdateDTO>} updateDTOs
     * @param {ForecastSimulationTreeOptionsDTO} options
     * @returns {Promise<ForecastSimulationUpdateResultDTO>}
     */

  }, {
    key: "updateSimulatedEntities",
    value: function updateSimulatedEntities(simulationId, updateDTOs, options) {
      var _this7 = this;

      var apiConfig = {
        responseType: 'json'
      }; // Converted updates to plain json

      var documentDTOs = updateDTOs.map(function (updateDTO) {
        return _this7.forecastSimulationUpdateDTOConverter.toDocument(updateDTO, jsonConversions);
      });
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_UPDATE(simulationId)).post(Object.assign({
        updates: documentDTOs
      }, options), apiConfig).then(function (response) {
        return _this7.forecastSimulationUpdateResultDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Append {@link DummyWindow} into simulation
     *
     * @param {string} simulationId
     * @param {DummyWindowAppendDTO} dummyData
     */

  }, {
    key: "appendDummyWindow",
    value: function appendDummyWindow(simulationId, dummyData) {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_APPEND_DUMMY_WINDOW(simulationId)).post(this.dummyWindowAppendDTOConverter.toDocument(dummyData, jsonConversions), apiConfig).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Deletes {@link DummyWindow} dependent session and origin data
     *
     * @param {string} simulationId
     * @param {string[]} windowIds
     * @returns {Promise<string[]>}
     */

  }, {
    key: "deleteDummyWindow",
    value: function deleteDummyWindow(simulationId, windowIds) {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_DELETE_DUMMY_WINDOW(simulationId)).post({
        windowIds: windowIds
      }, apiConfig).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Saves modified simulation for promotion
     *
     * @param {string} simulationId
     * @returns {Promise<ForecastSimulationSaveResultDTO>}
     */

  }, {
    key: "saveSimulation",
    value: function saveSimulation(simulationId) {
      var _this8 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_SAVE(simulationId)).post({}, apiConfig).then(function (response) {
        return _this8.forecastSimulationSaveResultDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return ForecastSimulationLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", TreeInfoDTOConverter)], ForecastSimulationLayer.prototype, "treeInfoDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastSimulationConflictDTOConverter)], ForecastSimulationLayer.prototype, "conflictConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastSimulationUpdateDTOConverter)], ForecastSimulationLayer.prototype, "forecastSimulationUpdateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastSimulationUpdateResultDTOConverter)], ForecastSimulationLayer.prototype, "forecastSimulationUpdateResultDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastSimulationSaveResultDTOConverter)], ForecastSimulationLayer.prototype, "forecastSimulationSaveResultDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SimulationFindCreateDTOConverter)], ForecastSimulationLayer.prototype, "simulationFindCreateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", DummyWindowAppendDTOConverter)], ForecastSimulationLayer.prototype, "dummyWindowAppendDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", PromotionSimulationConverter)], ForecastSimulationLayer.prototype, "promotionSimulationConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastSimulationLockDTOConverter)], ForecastSimulationLayer.prototype, "forecastSimulationLockDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ResourceLockResultDTOConverter)], ForecastSimulationLayer.prototype, "resourceLockResultDTOConverter", void 0);